import CityPageTemplate from "../city-template/CityPageTemplate";
import { mechanicsvilleVaConfig } from "./data";

export default function MechanicsvilleVaPage() {
  return <CityPageTemplate config={mechanicsvilleVaConfig} />;
}